export default __webpack_public_path__ + "static/media/add-my-list-done.cfcd49b2.svg";